import React from 'react'

export const Close: React.FC = () => {
  return (
    <path d="M9.06063 8L12.2656 4.795L12.9266 4.13406C13.0241 4.03656 13.0241 3.87813 12.9266 3.78063L12.2194 3.07344C12.1219 2.97594 11.9634 2.97594 11.8659 3.07344L8 6.93937L4.13406 3.07312C4.03656 2.97563 3.87812 2.97563 3.78062 3.07312L3.07312 3.78031C2.97563 3.87781 2.97563 4.03625 3.07312 4.13375L6.93937 8L3.07312 11.8659C2.97563 11.9634 2.97563 12.1219 3.07312 12.2194L3.78031 12.9266C3.87781 13.0241 4.03625 13.0241 4.13375 12.9266L8 9.06062L11.205 12.2656L11.8659 12.9266C11.9634 13.0241 12.1219 13.0241 12.2194 12.9266L12.9266 12.2194C13.0241 12.1219 13.0241 11.9634 12.9266 11.8659L9.06063 8Z" />
  )
}

export default Close
